import { currQrCodeImgSrc } from '@/utils/config'
interface VuexState {
  index: number
  userInfo: any
  currPoint: number
  shareVisible: boolean
  shareConfig: any
  pagIns: any
  qrCodeImg: string
  canAutoPlay: boolean
  audioLoaded: boolean
}
const state = (): VuexState => ({
  index: 0,
  userInfo: { isLogin: false },
  currPoint: 0,
  shareVisible: false,
  // 页面分享参数 & 活动id & 篇章纯享
  shareConfig: {
    title: '中国动画100年高光时刻',
    description: '中国动画100年高光时刻',
    avatar: '//i0.hdslb.com/bfs/ogv/activity/film-history/shareAvatar.png',
    editContent: '#中国动画100年高光时刻#',
  },
  pagIns: '',
  qrCodeImg: currQrCodeImgSrc,
  canAutoPlay: false, //  用户触发得以播放
  audioLoaded: false,
})
export default state
